module.exports = __webpack_public_path__ + "static/media/Novarese_BookItalic.75d6a8a1.svg";